/**
 * Cookie Banner
 *
 * @class rlCookies
 * @memberOf jQuery.fn
 */

(function($) {
    $.fn.rlCookies = function(myRefreshDate) {
        theRefreshDate = myRefreshDate;
        // Check cookie policy is on page
        if (document.querySelectorAll('#cookie-policy').length > 0) {
            var cookieNoticeClassList = document.getElementById('cookie-policy').classList, // List of classes on banner
                acceptCookies = document.getElementById('accept-cookies'), // Accept cookies button
                openClass = 'open', // Class used for showing banner
                closedClass = 'closed', // class used for closing banner
                openDelay = 500, // Sets the delay in ms before banner opens
                closeDelay = 250; // Sets delay for banner closing

            var cookieBanner = {
                RLCookieName: 'RlID',
                RLCookieDate: 'RlIDCREATION',
                currentRLPSID: '',
                domain: '',
                valid: false,


                // Check Banner State
                init: function() {
                    // Check for cookie, if it doesn't exist open cookie banner
                    var ns = cookieBanner;
                    var refreshDate = new Date(theRefreshDate);
                    //store system date
                    var systemDate = new Date();
                    systemDate = new Date(systemDate.setHours(0, 0, 0, 0));
                    //creation date
                    var creationDate = new Date(ns.readCookieDateValue());

                    ns.currentRLPSID = ns.getCookie();

                    ns.calculateDomain();

                    if (ns.currentRLPSID === null || ((refreshDate > creationDate) && (refreshDate <= systemDate) && (refreshDate !== ''))) {
                        cookieBanner.openBanner();
                        //delete the previous cookie
                        cookieBanner.deleteCookie();
                        // Trigger Browser Support Banner
                        // rl-SupportedBrowsers.js
                        $.fn.rlSupportedBrowsers.checkBrowser();

                    } else {
                        ns.setCookie();
                    }

                },

                // Open Banner
                openBanner: function() {
                    cookieNoticeClassList.remove(closedClass);
                    cookieNoticeClassList.add(openClass);

                    // Attach events to close button
                    acceptCookies.addEventListener('click', function(event) {
                        cookieBanner.closeBanner();
                        event.preventDefault();
                    }, false);



                    //change tabindex for tabbing accessibility reasons (open state)
                    $('.cookie-policy__content a').attr('tabindex', '1').attr('aria-hidden', 'false');
                    $('#accept-cookies').attr('tabindex', '1').attr('aria-hidden', 'false');;
                },

                // Close Banner
                closeBanner: function() {
                    // Delay before closing
                    setTimeout(function() {
                        cookieNoticeClassList.remove(openClass);
                        cookieNoticeClassList.add(closedClass);

                    }, closeDelay);

                    // Set cookie

                    ///  On the load of the file, check if there is a cookie, and refresh the expiry.
                    ///  Otherwise, if there is no cookie, then create a new one if they click to accept it.</summary>
                    'use strict';
                    var ns = cookieBanner;
                    ns.currentRLPSID = ns.createRLPSID();
                    ns.setCookie();
                    ns.dateCookie();

                    var valid = true;
                    localStorage.valid = valid;
                },

                createRLPSID: function() {
                    'use strict';
                    /// <summary>Create the RLPSID cookie policy unique ID</summary>

                    var newUUID = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                        var r = Math.random() * 16 | 0,
                            v = c == 'x' ? r : (r & 0x3 | 0x8);
                        return v.toString(16);
                    });

                    return newUUID;

                },

                setCookie: function() {
                    ///<summary>Set/Refresh the cookie with an expiry date of +30 days</summary>
                    'use strict';
                    var ns = cookieBanner;

                    var d = new Date();

                    d.setTime(d.getTime());
                    d.setMonth(d.getMonth() + 1); //set expiry to 1 month

                    var extraParams = ';expires=' + d.toUTCString();

                    if (ns.domain !== '') {
                        extraParams += ns.domain;
                    }

                    extraParams += ';path=/';
                    document.cookie = encodeURIComponent(ns.RLCookieName) + '=' + encodeURIComponent(ns.currentRLPSID) + extraParams;
                },

                deleteCookie: function() {
                    ///<summary>Delete the cookie</summary>
                    'use strict';
                    var ns = cookieBanner;

                    document.cookie = encodeURIComponent(ns.RLCookieName) + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;' + 'Path=/;';
                },

                dateCookie: function() {
                    ///<summary>Set a cookie with the value being the date the cookie was set</summary>
                    'use strict';
                    var ns = cookieBanner;

                    var dateValue = new Date();
                    var dateValue = new Date(dateValue.setHours(0, 0, 0, 0));
                    dateValue = dateValue.toUTCString();

                    //encode cookie value incase of any special characters 
                    dateValue = encodeURIComponent(dateValue);

                    var d = new Date();

                    d.setTime(d.getTime());
                    d.setMonth(d.getMonth() + 1); //set expiry to 1 month

                    var extraParams = ';expires=' + d.toUTCString();

                    if (ns.domain !== '') {
                        extraParams += ns.domain;
                    }

                    extraParams += ';path=/';
                    document.cookie = ns.RLCookieDate + '=' + dateValue + extraParams;
                },

                getCookie: function() {
                    ///<summary> Retrieve the unique Cookie id for any existant cookie</summary>
                    'use strict';

                    var regex = new RegExp('(?:^|;)\\s?' + cookieBanner.RLCookieName + '=(.*?)(?:;|$)', 'i')
                    var result = document.cookie.match(regex);

                    return (result === null) ? null : unescape(result[1]);
                },

                readCookieDateValue: function() {
                    //read value of cookie creation and decode cookie into a readable format
                    var decodedValue = decodeURIComponent(cookieBanner.RLCookieDate);
                    var re = new RegExp(decodedValue + "=([^;]+)");
                    var value = re.exec(document.cookie);
                    return (value != null) ? unescape(value[1]) : null;
                },

                calculateDomain: function() {
                    'use strict';
                    var ns = cookieBanner;
                    var regex = new RegExp(/\./g);
                    var domain = document.location.hostname.toString();
                    var count = 0;
                    try {
                        count = domain.match(regex).length;
                    } catch (err) {}

                    if (count > 1) {
                        domain = domain.substring(domain.indexOf('.') + 1);
                        ns.domain = ';domain=' + domain;
                    }
                    else {
                        ns.domain = ';domain=' + domain;
                    }
                }
            };

            // Init banner
            setTimeout(function() {
                cookieBanner.init();
            }, openDelay);
        }

        //Add tabindex of cookie banner (closed state)
        $('.cookie-policy__content a').attr('tabindex', '-1').attr('aria-hidden', 'true');
        $('#accept-cookies').attr('tabindex', '-1').attr('aria-hidden', 'true');

        //Change (on acceptance) tabindex of cookie banner - EG make it hidden to keyboard focus
        $('#accept-cookies').on('click', function() {
            $('.cookie-policy__content a').attr('tabindex', '-1').attr('aria-hidden', 'true');
            $(this).attr('tabindex', '-1').attr('aria-hidden', 'true');
        });

        //spacebar functionality
        $('.cookie-policy a').on('focusin', function (el) {

            attr = $(this).attr('href'),
            currentclassname = $(this).attr('class');
            currentid = $(this).attr('id');

            if (typeof attr !== typeof undefined && attr !== false) {
                var thisurl = $(this).attr('href');
            }
            else {
                var thisurl = '';
            }

            var target = el.target;

            window.onkeydown = function (event) {
              if (event.keyCode === 32 && target === document.activeElement) {

                    if (thisurl !== null && thisurl !== '') {
                        event.preventDefault();
                        window.location.href = thisurl;
                    }

                    if (currentid === 'accept-cookies') {
                        event.preventDefault();

                        // Delay before closing
                        setTimeout(function () {
                            cookieNoticeClassList.remove(openClass);
                            cookieNoticeClassList.add(closedClass);

                        }, closeDelay);

                        // Set cookie

                        ///  On the load of the file, check if there is a cookie, and refresh the expiry.
                        ///  Otherwise, if there is no cookie, then create a new one if they click to accept it.</summary>
                        'use strict';
                        var ns = cookieBanner;
                        ns.currentRLPSID = ns.createRLPSID();
                        ns.setCookie();
                        ns.dateCookie();

                        var valid = true;
                        localStorage.valid = valid; 
                    }
                }
            }
        })
    };
}(jQuery));
